import { render } from "./livehealth-online.vue?vue&type=template&id=77dc105d"
import script from "./livehealth-online.vue?vue&type=script&lang=js"
export * from "./livehealth-online.vue?vue&type=script&lang=js"

import "./livehealth-online.vue?vue&type=style&index=0&id=77dc105d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__